
import { defineComponent } from "vue";
import { Rect } from "@/utils/components/Rect";
import { Template } from "@/utils/components/Template";
import ColorInput from "../ColorInput.vue";

export default defineComponent({
  components: { ColorInput },
  data() {
    return {
      inputTransformer: Template.inputTransformer
    };
  },

  props: {
    component: {
      type: Object as () => Rect,
      required: true
    },
    maxHeight: {
      type: Number,
      required: true
    },
    maxWidth: {
      type: Number,
      required: true
    }
  },

  watch: {
    component: {
      deep: true,
      handler() {
        this.ensureBounds();
      }
    }
  },

  methods: {
    ensureBounds() {
      const bounds = this.component.getBoundingBox();
      bounds.ensureBounds(this.maxWidth, this.maxHeight);
      this.component.modify(bounds);

      const minDim = Math.min(this.component.height, this.component.width);
      if (this.component.radius > minDim / 2) {
        this.component.radius = Math.floor(minDim / 2);
      }
    }
  }
});
